export default __webpack_public_path__ + "081fa188b65fb4393803ae48cc83241d.woff";